export const SELECT_PROJECT_SUCCESS = 'SELECT_PROJECT_SUCCESS';
export const SELECT_PROJECT_FAILED = 'SELECT_PROJECT_FAILED';